<template>
  <div>
    <div class="col-md-6"><strong>Эксперт (ФИО, должность)</strong></div>
    <div class="col-md-6 form-group" >
      <input type="text" class='form-control' v-model="expertInfo.fio"/>
    </div>
    <div class="col-md-6"><strong>Дата посещения</strong></div>
    <div class="col-md-6 form-group">
      <input type="text" class='form-control' v-model="expertInfo.date"/>
    </div>
    <div class="col-md-6"><strong>Представитель (ФИО, должность)</strong></div>
    <div class="col-md-6 form-group">
      <input type="text" class='form-control' v-model="expertInfo.pred"/>
    </div>
    <div class="col-md-12">
      <div class="col-md-12">
        <h3>Наличие конфортных учловий для предоставления услуг</h3>
      </div>
      <div class="row">
        <div class="col-md-6">Отсутствуют конфортные условия</div>
        <div class="col-md-6">
          <label for="input1_1">Да</label>
          <input type="radio" name="input1" id="input1_1" v-model="anketForm[0]" value="0" />
          <input type="file" v-show="anketForm[0] == 0 && fileLoaded[0] != 1 && uploadedFiles[0] == undefined" @change="previeFile(0)" name="file" />
          <span class="badge badge-success" v-show="fileLoaded[0] == 1">Загружено</span>
          <label for="input1_2">Нет</label>
          <input type="radio" name="input1" id="input1_2" v-model="anketForm[0]" value="1" />
          <a target="_blank" :href='uploadedFiles[0]' v-show="uploadedFiles[0] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[0] != undefined" @click='uploadedFiles[0] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Наличие конфортной зоны отдыха оборудованной соответсвующей мебелью</div>
        <div class="col-md-6">
          <label for="input2_1">Да</label>
          <input type="radio" name="input2" id="input2_1" v-model="anketForm[1]" value="0" />
          <input type="file" v-show="anketForm[1] == 0 && fileLoaded[1] != 1 && uploadedFiles[1] == undefined" @change="previeFile(1)" name="file" />
          <span class="badge badge-success" v-show="fileLoaded[1] == 1">Загружено</span>
          <label for="input2_2">Нет</label>
          <input type="radio" name="input2" id="input2_2" v-model="anketForm[1]" value="1" />
          <a target="_blank" :href='uploadedFiles[1]' v-show="uploadedFiles[1] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[1] != undefined" @click='uploadedFiles[1] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Наличие и понятность навигации внутри организации социальной сферы</div>
        <div class="col-md-6">
          <label for="input3_1">Да</label>
          <input type="radio" name="input3" id="input3_1" v-model="anketForm[2]" value="0" /><input type='file' v-show="anketForm[2]==0 && fileLoaded[2]!=1 && uploadedFiles[2] == undefined" @change="previeFile(2)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[2] == 1">Загружено</span>
        
          <label for="input3_2">Нет</label>
          <input type="radio" name="input3" id="input3_2" v-model="anketForm[2]" value="1" />
          <a target="_blank" :href='uploadedFiles[2]' v-show="uploadedFiles[2] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[2] != undefined" @click='uploadedFiles[2] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Наличие и доступность питьевой воды</div>
        <div class="col-md-6">
          <label for="input4_1">Да</label>
          <input type="radio" name="input4" id="input4_1" v-model="anketForm[3]" value="0" /><input type='file' v-show="anketForm[3]==0 && fileLoaded[3]!=1 && uploadedFiles[3] == undefined" @change="previeFile(3)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[3] == 1">Загружено</span>

          <label for="input4_2">Нет</label>
          <input type="radio" name="input4" id="input4_2" v-model="anketForm[3]" value="1" />
          <a target="_blank" :href='uploadedFiles[3]' v-show="uploadedFiles[3] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[3] != undefined" @click='uploadedFiles[3] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Наличие и доступность санитарно-гигиенических помещений</div>
        <div class="col-md-6">
          <label for="input5_1">Да</label>
          <input type="radio" name="input5" id="input5_1" v-model="anketForm[4]" value="0" /><input type='file' v-show="anketForm[4]==0 && fileLoaded[4]!=1 && uploadedFiles[4] == undefined" @change="previeFile(4)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[4] == 1">Загружено</span>

          <label for="input5_2">Нет</label>
          <input type="radio" name="input5" id="input5_2" v-model="anketForm[4]" value="1" />
          <a target="_blank" :href='uploadedFiles[4]' v-show="uploadedFiles[4] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[4] != undefined" @click='uploadedFiles[4] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Санитарное состояние помещений организации социальной сферы</div>
        <div class="col-md-6">
          <label for="input6_1">Да</label>
          <input type="radio" name="input6" id="input6_1" v-model="anketForm[5]" value="0" /><input type='file' v-show="anketForm[5]==0 && fileLoaded[5]!=1 && uploadedFiles[5] == undefined" @change="previeFile(5)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[5] == 1">Загружено</span>

          <label for="input6_2">Нет</label>
          <input type="radio" name="input6" id="input6_2" v-model="anketForm[5]" value="1" />
          <a target="_blank" :href='uploadedFiles[5]' v-show="uploadedFiles[5] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[5] != undefined" @click='uploadedFiles[5] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6"
        >Транспортная доступность (возможность доехать до организации социальной сферы на общественном транспорте, наличие парковки</div>
        <div class="col-md-6">
          <label for="input7_1">Да</label>
          <input type="radio" name="input7" id="input7_1" v-model="anketForm[6]" value="0" /><input type='file' v-show="anketForm[6]==0 && fileLoaded[6]!=1 && uploadedFiles[6] == undefined" @change="previeFile(6)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[6] == 1">Загружено</span>

          <label for="input7_2">Нет</label>
          <input type="radio" name="input7" id="input7_2" v-model="anketForm[6]" value="1" />
          <a target="_blank" :href='uploadedFiles[6]' v-show="uploadedFiles[6] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[6] != undefined" @click='uploadedFiles[6] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6"
        >Доступность записи на получение услуги (по телефону, на официальном сайте организации социальной сферы в сети "Интернет", посредством Единого портала государственных и муниципальных услуг, при личном посещении в регистратуре или у специалиста организации социальной сферы и пр.)</div>
        <div class="col-md-6">
          <label for="input8_1">Да</label>
          <input type="radio" name="input8" id="input8_1" v-model="anketForm[7]" value="0" /><input type='file' v-show="anketForm[7]==0 && fileLoaded[7]!=1 && uploadedFiles[7] == undefined" @change="previeFile(7)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[7] == 1">Загружено</span>

          <label for="input8_2">Нет</label>
          <input type="radio" name="input8" id="input8_2" v-model="anketForm[7]" value="1" />
          <a target="_blank" :href='uploadedFiles[7]' v-show="uploadedFiles[7] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[7] != undefined" @click='uploadedFiles[7] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6"
        >Иные параметры комфортных условий, установленные ведомственным актом уполномоченного федерального органа исполнительной власти</div>
        <div class="col-md-6">
          <label for="input9_1">Да</label>
          <input type="radio" name="input9" id="input9_1" v-model="anketForm[8]" value="0" /><input type='file' v-show="anketForm[8]==0 && fileLoaded[8]!=1 && uploadedFiles[8] == undefined" @change="previeFile(8)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[8] == 1">Загружено</span>

          <label for="input9_2">Нет</label>
          <input type="radio" name="input9" id="input9_2" v-model="anketForm[8]" value="1" />
          <a target="_blank" :href='uploadedFiles[8]' v-show="uploadedFiles[8] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[8] != undefined" @click='uploadedFiles[8] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Особое мнение</div>
        <div class="col-md-6 form-group">
          <textarea v-model="textArea[0]" class='form-control'></textarea>
        </div>
      </div>

      <div class="col-md-12">
        <h3>Наличие в помещениях организации социальной сферы и на прилегающей к ней территории условий доступности для инвалидов:</h3>
      </div>
      <div class="row">
        <div class="col-md-6">отсутствуют условия доступности для инвалидов</div>
        <div class="col-md-6">
          <label for="input10_1">Да</label>
          <input type="radio" name="input10" id="input10_1" v-model="anketForm[9]" value="0" /><input type='file' v-show="anketForm[9]==0 && fileLoaded[9]!=1 && uploadedFiles[9] == undefined" @change="previeFile(9)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[9] == 1">Загружено</span>

          <label for="input10_2">Нет</label>
          <input type="radio" name="input10" id="input10_2" v-model="anketForm[9]" value="1" />
          <a target="_blank" :href='uploadedFiles[9]' v-show="uploadedFiles[9] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[9] != undefined" @click='uploadedFiles[9] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">оборудованных входных групп пандусами (подъемными платформами)</div>
        <div class="col-md-6">
          <label for="input11_1">Да</label>
          <input type="radio" name="input11" id="input11_1" v-model="anketForm[10]" value="0" /><input type='file' v-show="anketForm[10]==0 && fileLoaded[10]!=1 && uploadedFiles[10] == undefined" @change="previeFile(10)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[10] == 1">Загружено</span>

          <label for="input11_2">Нет</label>
          <input type="radio" name="input11" id="input11_2" v-model="anketForm[10]" value="1" />
          <a target="_blank" :href='uploadedFiles[10]' v-show="uploadedFiles[10] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[10] != undefined" @click='uploadedFiles[10] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">выделенных стоянок для автотранспортных средств инвалидов</div>
        <div class="col-md-6">
          <label for="input12_1">Да</label>
          <input type="radio" name="input12" id="input12_1" v-model="anketForm[11]" value="0" /><input type='file' v-show="anketForm[11]==0 && fileLoaded[11]!=1 && uploadedFiles[11] == undefined" @change="previeFile(11)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[11] == 1">Загружено</span>

          <label for="input12_2">Нет</label>
          <input type="radio" name="input12" id="input12_2" v-model="anketForm[11]" value="1" />
          <a target="_blank" :href='uploadedFiles[11]' v-show="uploadedFiles[11] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[11] != undefined" @click='uploadedFiles[11] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">адаптированных лифтов, поручней, расширенных дверных проемов</div>
        <div class="col-md-6">
          <label for="input13_1">Да</label>
          <input type="radio" name="input13" id="input13_1" v-model="anketForm[12]" value="0" /><input type='file' v-show="anketForm[12]==0 && fileLoaded[12]!=1 && uploadedFiles[12] == undefined" @change="previeFile(12)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[12] == 1">Загружено</span>

          <label for="input13_2">Нет</label>
          <input type="radio" name="input13" id="input13_2" v-model="anketForm[12]" value="1" />
          <a target="_blank" :href='uploadedFiles[12]' v-show="uploadedFiles[12] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[12] != undefined" @click='uploadedFiles[12] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">сменных кресел-колясок</div>
        <div class="col-md-6">
          <label for="input14_1">Да</label>
          <input type="radio" name="input14" id="input14_1" v-model="anketForm[13]" value="0" /><input type='file' v-show="anketForm[13]==0 && fileLoaded[13]!=1 && uploadedFiles[13] == undefined" @change="previeFile(13)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[13] == 1">Загружено</span>

          <label for="input14_2">Нет</label>
          <input type="radio" name="input14" id="input14_2" v-model="anketForm[13]" value="1" />
          <a target="_blank" :href='uploadedFiles[13]' v-show="uploadedFiles[13] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[13] != undefined" @click='uploadedFiles[13] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">сменных кресел-колясок</div>
        <div class="col-md-6">
          <label for="input15_1">Да</label>
          <input type="radio" name="input15" id="input15_1" v-model="anketForm[14]" value="0" /><input type='file' v-show="anketForm[14]==0 && fileLoaded[14]!=1 && uploadedFiles[14] == undefined" @change="previeFile(14)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[14] == 1">Загружено</span>

          <label for="input15_2">Нет</label>
          <input type="radio" name="input15" id="input15_2" v-model="anketForm[14]" value="1" />
          <a target="_blank" :href='uploadedFiles[14]' v-show="uploadedFiles[14] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[14] != undefined" @click='uploadedFiles[14] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6"
        >специально оборудованных санитарно-гигиенических помещений в организации социальной сферы</div>
        <div class="col-md-6">
          <label for="input16_1">Да</label>
          <input type="radio" name="input16" id="input16_1" v-model="anketForm[15]" value="0" /><input type='file' v-show="anketForm[15]==0 && fileLoaded[15]!=1 && uploadedFiles[15] == undefined" @change="previeFile(15)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[15] == 1">Загружено</span>

          <label for="input16_2">Нет</label>
          <input type="radio" name="input16" id="input16_2" v-model="anketForm[15]" value="1" />
          <a target="_blank" :href='uploadedFiles[15]' v-show="uploadedFiles[15] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[15] != undefined" @click='uploadedFiles[15] = undefined'></i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">Особое мнение</div>
        <div class="col-md-6 form-group">
          <textarea v-model="textArea[1]" class='form-control'></textarea>
        </div>
      </div>

      <div class="col-md-12">
        <h3>Наличие в организации социальной сферы условий доступности, позволяющих инвалидам получать услуги наравне с другими:</h3>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >отсутствуют условия доступности, позволяющие инвалидам получать услуги наравне с другими</div>
        <div class="col-md-6">
          <label for="input18_1">Да</label>
          <input type="radio" name="input18" id="input18_1" v-model="anketForm[16]" value="0" /><input type='file' v-show="anketForm[16]==0 && fileLoaded[16]!=1 && uploadedFiles[16] == undefined" @change="previeFile(16)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[16] == 1">Загружено</span>

          <label for="input18_2">Нет</label>
          <input type="radio" name="input18" id="input18_2" v-model="anketForm[16]" value="1" />
          <a target="_blank" :href='uploadedFiles[16]' v-show="uploadedFiles[16] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[16] != undefined" @click='uploadedFiles[16] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >дублирование для инвалидов по слуху и зрению звуковой и зрительной информации</div>
        <div class="col-md-6">
          <label for="input19_1">Да</label>
          <input type="radio" name="input19" id="input19_1" v-model="anketForm[17]" value="0" /><input type='file' v-show="anketForm[17]==0 && fileLoaded[17]!=1 && uploadedFiles[17] == undefined" @change="previeFile(17)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[17] == 1">Загружено</span>

          <label for="input19_2">Нет</label>
          <input type="radio" name="input19" id="input19_2" v-model="anketForm[17]" value="1" />
          <a target="_blank" :href='uploadedFiles[17]' v-show="uploadedFiles[17] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[17] != undefined" @click='uploadedFiles[17] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >дублирование надписей, знаков и иной текстовой и графической информации знаками, выполненными рельефно-точечным шрифтом Брайля</div>
        <div class="col-md-6">
          <label for="input20_1">Да</label>
          <input type="radio" name="input20" id="input20_1" v-model="anketForm[18]" value="0" /><input type='file' v-show="anketForm[18]==0 && fileLoaded[18]!=1 && uploadedFiles[18] == undefined" @change="previeFile(18)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[18] == 1">Загружено</span>

          <label for="input20_2">Нет</label>
          <input type="radio" name="input20" id="input20_2" v-model="anketForm[18]" value="1" />
          <a target="_blank" :href='uploadedFiles[18]' v-show="uploadedFiles[18] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[18] != undefined" @click='uploadedFiles[18] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >возможность предоставления инвалидам по слуху (слуху и зрению) услуг сурдопереводчика (тифлосурдопереводчика)</div>
        <div class="col-md-6">
          <label for="input21_1">Да</label>
          <input type="radio" name="input21" id="input21_1" v-model="anketForm[19]" value="0" /><input type='file' v-show="anketForm[19]==0 && fileLoaded[19]!=1 && uploadedFiles[19] == undefined" @change="previeFile(19)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[19] == 1">Загружено</span>

          <label for="input21_2">Нет</label>
          <input type="radio" name="input21" id="input21_2" v-model="anketForm[19]" value="1" />
          <a target="_blank" :href='uploadedFiles[19]' v-show="uploadedFiles[19] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[19] != undefined" @click='uploadedFiles[19] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >наличие альтернативной версии официального сайта организации социальной сферы в сети "Интернет" для инвалидов по зрению</div>
        <div class="col-md-6">
          <label for="input22_1">Да</label>
          <input type="radio" name="input22" id="input22_1" v-model="anketForm[20]" value="0" /><input type='file' v-show="anketForm[20]==0 && fileLoaded[20]!=1 && uploadedFiles[20] == undefined" @change="previeFile(20)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[20] == 1">Загружено</span>

          <label for="input22_2">Нет</label>
          <input type="radio" name="input22" id="input22_2" v-model="anketForm[20]" value="1" />
          <a target="_blank" :href='uploadedFiles[20]' v-show="uploadedFiles[20] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[20] != undefined" @click='uploadedFiles[20] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >помощь, оказываемая работниками организации социальной сферы, прошедшими необходимое обучение (инструктирование) по сопровождению инвалидов в помещениях организации социальной сферы и на прилегающей территории</div>
        <div class="col-md-6">
          <label for="input23_1">Да</label>
          <input type="radio" name="input23" id="input23_1" v-model="anketForm[21]" value="0" /><input type='file' v-show="anketForm[21]==0 && fileLoaded[21]!=1 && uploadedFiles[21] == undefined" @change="previeFile(21)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[21] == 1">Загружено</span>

          <label for="input23_2">Нет</label>
          <input type="radio" name="input23" id="input23_2" v-model="anketForm[21]" value="1" />
          <a target="_blank" :href='uploadedFiles[21]' v-show="uploadedFiles[21] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[21] != undefined" @click='uploadedFiles[21] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-6"
        >наличие возможности предоставления услуги в дистанционном режиме или на дому</div>
        <div class="col-md-6">
          <label for="input24_1">Да</label>
          <input type="radio" name="input24" id="input24_1" v-model="anketForm[22]" value="0" /><input type='file' v-show="anketForm[22]==0 && fileLoaded[22]!=1 && uploadedFiles[22] == undefined" @change="previeFile(22)" name='file' /> <span class='badge badge-success' v-show="fileLoaded[22] == 1">Загружено</span>

          <label for="input24_2">Нет</label>
          <input type="radio" name="input24" id="input24_2" v-model="anketForm[22]" value="1" />
          <a target="_blank" :href='uploadedFiles[22]' v-show="uploadedFiles[22] != undefined">Просмотр</a>
          <i class="fas fa-upload" v-show="uploadedFiles[22] != undefined" @click='uploadedFiles[22] = undefined'></i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">Особое мнение</div>
        <div class="col-md-6 form-group">
          <textarea v-model="textArea[2]" class='form-control'></textarea>
        </div>
      </div>

      <button @click="sendFormData()" class='btn btn-success'>Сохранить</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import nprogress from 'nprogress';

export default {
created: function() {
    this.loadData();
    this.getUploadedFoto();
},
  methods: {
    getUploadedFoto: function(){
      nprogress.start();
      axios({
        url: "http://eduqa.egechita.ru/back/getuploadedexpertfoto/"+this.$route.params.id,
        withCredentials: true
      }).then(Response => {
        nprogress.done();
        this.uploadedFiles = Response.data;
      });
    },
    loadData: function(){
        nprogress.start();
        axios({
            url: "http://eduqa.egechita.ru/back/getanketaexpertschoolinfo/"+this.$route.params.id,
            withCredentials: true
        }).then((Response) => {
            if (Response.data.status == 1){
            this.expertInfo = Response.data.info.expertInfo,
            this.anketForm = Response.data.info.anketa,
            this.textArea = Response.data.info.text;
            }
            nprogress.done();
        });
    },
    previeFile: function(id) {
      nprogress.start();
      var formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append("quest_id", id);
      formData.append("school_id", this.$route.params.id);
      axios
        .post("http://eduqa.egechita.ru/back/expertfotoupload", formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(Response => {
            nprogress.done();
            this.$set(this.fileLoaded, Response.data.fileId, 1);
        });
    },
    sendFormData: function() {
        nprogress.start();
      axios({
        withCredentials: true,
        url: "http://eduqa.egechita.ru/back/anketaexpertastopisat",
        data: {
            expertInfo: this.expertInfo,
            anketa: this.anketForm,
            text: this.textArea,
            school: this.$route.params.id
        },
        method: "POST"
      }).then((Response) => {nprogress.done()});
    }
  },
  data() {
    return { textArea: [], anketForm: [], file: [], fileLoaded: [],
    uploadedFiles: [],
    expertInfo:{
        fio:"",
        date: "",
        pred: ""
    } };
  }
};
</script>

<style>
</style>